import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import DebtReliefCornerWrapper from "@components/layouts/debtReliefCornerWrapper";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
export default function ContactUsHome(): ReactElement {
    return (
        <DebtReliefCornerWrapper>
            <div className="bg-white">
                <ContactTop iconsFillColor={"#D0D1FF"} />
            </div>
            <FormSection iconsFillColor={"#FF823C"} />
        </DebtReliefCornerWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
